import React, { useEffect } from 'react';

import MarketingHeader from '../components/MarketingHeader';
import '../styles/MarketingTheme.css';



const TermsPage = () => {


    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="marketing-page stunning-theme">
            <MarketingHeader />

            {/* Main Content */}
            <div className="marketing-container mt-4 mb-lg">
                <div className="legal-layout">
                    {/* Sidebar Navigation */}
                    <aside className="marketing-legal-sidebar hidden md:block">
                        <div className="mb-4">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">On this page</p>
                            <nav className="flex flex-col space-y-2">
                                <button onClick={() => scrollToSection('acceptance')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">1. Acceptance</button>
                                <button onClick={() => scrollToSection('license')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">2. Software License</button>
                                <button onClick={() => scrollToSection('billing')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">3. Subscription & Billing</button>
                                <button onClick={() => scrollToSection('content')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">4. User Content</button>
                                <button onClick={() => scrollToSection('termination')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">5. Termination</button>
                            </nav>
                        </div>
                        <div className="mt-8 pt-6 border-t border-white/10">
                            <p className="text-xs text-gray-500 mb-2">Have questions?</p>
                            <a href="mailto:support@redsorm.in" className="text-sm text-purple-400 hover:text-purple-300 font-medium">Contact Support →</a>
                        </div>
                    </aside>

                    {/* Document Content */}
                    <article className="marketing-legal-content">
                        <div className="flex items-center gap-2 mb-8">
                            <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                            <span className="text-sm text-gray-400">Effective: {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                        </div>

                        <h1>Terms of Service</h1>
                        <p className="lead text-lg text-gray-300 mb-10 border-b border-white/10 pb-8">
                            These terms govern your access to the RedSorm platform. By using our services, you agree to these legal obligations.
                        </p>

                        <div id="acceptance" className="mb-12">
                            <h2>1. Acceptance of Terms</h2>
                            <p>By accessing and using RedSorm ("Service"), you accept and agree to be bound by the terms and provision of this agreement. In addition, when using these particular services, you shall be subject to any posted guidelines or rules applicable to such services.</p>
                        </div>

                        <div id="license" className="mb-12">
                            <h2>2. Software License</h2>
                            <p>We grant you a limited, non-exclusive, non-transferable, and revocable license to use our Services for your internal business operations. You may not:</p>
                            <ul className="list-disc pl-5 space-y-2 text-gray-400 mb-6">
                                <li>Reverse engineer, decompile, or disassemble the object code.</li>
                                <li>Resell or sublicense the software to unauthorized third parties.</li>
                                <li>Use the service to build a competitive product.</li>
                            </ul>
                        </div>

                        <div id="billing" className="mb-12">
                            <h2>3. Subscriptions & Billing</h2>
                            <p>You agree to pay the fees applicable to your subscription plan. All payments are non-refundable generally, except as expressly provided in these Terms.</p>

                            <div className="grid md:grid-cols-2 gap-4 mt-6">
                                <div className="marketing-card p-4 bg-white/5 border-none">
                                    <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center text-green-400 mb-4">
                                        <i className="fas fa-calendar-check"></i>
                                    </div>
                                    <h3 className="text-lg font-bold text-white mb-2">Auto-Renewal</h3>
                                    <p className="text-sm text-gray-400">Subscriptions automatically renew at the end of each billing cycle unless cancelled.</p>
                                </div>
                                <div className="marketing-card p-4 bg-white/5 border-none">
                                    <div className="w-10 h-10 rounded-full bg-orange-500/20 flex items-center justify-center text-orange-400 mb-4">
                                        <i className="fas fa-file-invoice-dollar"></i>
                                    </div>
                                    <h3 className="text-lg font-bold text-white mb-2">Taxes</h3>
                                    <p className="text-sm text-gray-400">Prices are exclusive of all taxes, levies, or duties imposed by taxing authorities.</p>
                                </div>
                            </div>
                        </div>

                        <div id="content" className="mb-12">
                            <h2>4. User Content</h2>
                            <p>You retain all rights to the data, content, and information you upload to the Service. You grant RedSorm a worldwide license to host and use your content solely to provide the Service to you.</p>
                        </div>

                        <div id="termination" className="mt-12 pt-8 border-t border-white/10">
                            <h2>5. Termination</h2>
                            <p>We reserve the right to suspend or terminate your account if you violate these Terms or engage in illegal activity using our platform.</p>
                            <div className="mt-6 bg-red-900/20 border border-red-900/30 p-4 rounded-xl">
                                <h4 className="text-red-400 font-bold text-sm mb-1">Critical Violation</h4>
                                <p className="text-red-300 text-sm">Any attempt to disrupt the integrity of our servers will result in immediate termination.</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>

            {/* Footer */}
            <footer className="marketing-footer">
                <div className="marketing-footer-content">
                    <p>&copy; {new Date().getFullYear()} RedSorm. All rights reserved.</p>
                    <div className="marketing-footer-links">
                        <a href="/terms-of-service" className="marketing-footer-link">Terms</a>
                        <a href="/privacy-policy" className="marketing-footer-link">Privacy</a>
                        <a href="/cookie-policy" className="marketing-footer-link">Cookies</a>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default TermsPage;
